import { Box } from "@mui/material";

import { fetchFromServer } from "../../service/graph-req";
import Client from "./Client";

export default async function LandingPage() {
  const modelList = await getModelList();

  return (
    <Box bgcolor="dark.surface.color" overflow="auto">
      <Client modelList={modelList} />
    </Box>
  );
}

export const Section = ({ children, ...props }) => (
  <Box minHeight="100vh" px={{ compact: 2, expanded: 0 }} {...props}>
    {children}
  </Box>
);

async function getModelList() {
  try {
    const modelList = await fetchFromServer(
      "model/list",
      process.env.MODEL_KEY,
      true
    );
    const list = modelList
      .map(model => ({
        ...model,
        org: model.modelId.split("/")[0],
        name: model.modelId.split("/")[1]
      }))
      .sort((a, b) => a.org.toLowerCase().localeCompare(b.org.toLowerCase()));
    const getModel = modelId => list.find(model => model.modelId === modelId);

    return {
      list,
      prices: {
        sm: getModel("facebook/galactica-125m"),
        md: getModel("microsoft/phi-1"),
        lg: getModel("togethercomputer/Llama-2-7B-32K-Instruct"),
        xl: getModel("NousResearch/Meta-Llama-3-70B-Instruct")
      }
    };
  } catch (error) {
    console.error(error);

    return { list: [], pricing: {} };
  }
}
